import ApplicationController from './application_controller'
import { ClassToggler } from '../classes/classToggler'
import { useDispatch } from 'stimulus-use'
import { getCookie, setCookie } from '@app/javascript/classes/cookies'

export default class extends ApplicationController {
  static targets = ['item']
  static values = { initialStateCookie: String }

  doConnect() {
    useDispatch(this)

    if (this.initialState()) {
      this.itemTargets.forEach((item) => {
        this.toggleItem(item)
      })
    }
  }

  toggleItems(event) {
    if (!this.isActionDisabled('toggleItems')) {
      const itemsToToggle = this.getParam(event.currentTarget, 'item-refs-id').split(' ')

      this.itemTargets.forEach((item) => {
        if (itemsToToggle.include(this.getParam(item, 'item-id'))) {
          this.toggleItem(item)
        }
      })
    }
  }

  toggleAll(event) {
    this.detectKeyStrokes(event, () => {
      if (this.validateEventTriggeredByCurrentTarget(event, 'toggleAll') &&
        !this.isActionDisabled('toggleAll')) {
        this.itemTargets.forEach((item) => {
          this.toggleItem(item)
        })
      }
      this.toggleInitialState()
    })
  }

  removeAll(event) {
    if (this.validateEventTriggeredByCurrentTarget(event, 'removeAll') &&
      !this.isActionDisabled('removeAll')) {
      this.itemTargets.forEach((item) => {
        this.removeAllItemClasses(item)
      })
    }
  }

  addAll(event) {
    if (this.validateEventTriggeredByCurrentTarget(event, 'addAll') &&
      !this.isActionDisabled('addAll')) {
      this.itemTargets.forEach((item) => {
        this.addAllItemClasses(item)
      })
    }
  }

  // Toggle all items back to their original state.
  toggleAllBackToOriginal() {
    if (!this.isActionDisabled('toggleAll')) {
      this.itemTargets.forEach((item) => {
        this.addAllItemClasses(item)
      })
    }
  }

  removeAllItemClasses(item) {
    this.itemClassToggler(item).removeAllClasses()
  }

  addAllItemClasses(item) {
    this.itemClassToggler(item).addAllClasses()
  }

  toggleItem(item) {
    this.itemClassToggler(item).toggleAllClasses()
  }

  toggleInitialState() {
    if (this.initialStateCookieValue) {
      setCookie(this.initialStateCookieValue, !this.initialState())
    }
  }

  initialState() {
    return this.initialStateCookieValue && getCookie(this.initialStateCookieValue) === 'true'
  }

  itemClassToggler(item) {
    const itemClassToToggle = this.getParam(item, 'item-classes-toggle')
    return new ClassToggler(item, itemClassToToggle)
  }
}
